<template>
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="talks"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      multi-sort
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Talks"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Talk
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-talk-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {TalkModel} from "@/modules/redactor/models/talks/TalkModel";

import RTalkDialog from "@/modules/redactor/views/talk/r-talk-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  components: {RDialogPreviewCollection, AcDataTable, RTalkDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Name", value: "name"},
      {text: "Key", value: "key"},
      {text: "Status", value: "enabled"},
      {text: "ID", value: "id"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    talks: {
      type: VueTypes.arrayOf(TalkModel)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(talk) {
      this.$refs['dialog'].show(ViewRules.COPY, talk.copy()).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushTalk(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushTalk(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },
    row_update(talk) {
      this.$refs['dialog'].show(ViewRules.UPDATE, talk.clone()).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushTalk(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeTalk(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkTalks(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushTalk(result);
    },

    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },

    item_duplicate(item) {
      return this.talks.find(v => {
        if (v.id && item.id && v.id === item.id) {
          return v.uid !== item.uid;
        }

        if (v.key && item.key && v.key === item.key) {
          return v.uid !== item.uid;
        }

        return false;
      });
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.talks, TalkModel, "talk")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.talks = RedactorUtils.getTalks();
  }
};
</script>